import React from 'react';
import {Link, LinkProps} from 'react-router-dom';

const RouterLink = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (props, ref) => <Link innerRef={ref as any} {...props} />
);

export default RouterLink;
